import { render, staticRenderFns } from "./GroupDevicesTab.html?vue&type=template&id=3e808624&"
import script from "./GroupDevicesTab.ts?vue&type=script&lang=ts&"
export * from "./GroupDevicesTab.ts?vue&type=script&lang=ts&"
import style0 from "./GroupDevicesTab.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
